import { connect } from 'react-redux'

import { applyFilter } from '../../redux/modules/search/actions'

import AllFilters from '../../components/filters/AllFilters'

const mapStateToProps = (state) => ({
  minBeds: state.search.filters.minBeds || 1,
  maxBeds: state.search.filters.maxBeds || 10,
  minBedrooms: state.search.filters.minBedrooms || 0,
  maxBedrooms: state.search.filters.maxBedrooms || 10,
  minBudget: state.search.filters.minBudget || 1,
  maxBudget: state.search.filters.maxBudget || 5,
  types: state.search.filters.types || [],
  amenities: state.search.filters.amenities || [],
  typeCounts: state.search.pagination.types || {},
  amenityCounts: state.search.pagination.amenities || {},
  amenityDefinition: state.search.amenities || {},
})

const actionCreators = { applyFilter }
export default connect(mapStateToProps, actionCreators)(AllFilters)



// WEBPACK FOOTER //
// ./src/containers/filters/AllFilters.js